export default "__VITE_ASSET__B0Icg0$q__"